import { RISK_STATUS } from '../shared/reputation-risk-status';

const getRiskStatus = ({shouldBlock, riskScore}) => {
    if (shouldBlock) {
        return RISK_STATUS.HIGH;
    }

    if (riskScore > 20) {
        return RISK_STATUS.MEDIUM;
    }

    return RISK_STATUS.LOW;
};

const emailReputationMapper = {
    toDomain(data) {
        return {
            type: 'email',
            riskScore: 100 - data.trustScore,
            shouldBlock: data.shouldBlock,
            riskStatus: getRiskStatus({...data, riskScore: 100 - data.trustScore}),
            isValid: data.isValid,
            isFree: data.isFree,
            weakSecurity: data.weakSecurity,
            isDomainSuspicious: data.isDomainSuspicious,
            isEmailSuspicious: data.isEmailSuspicious,
            isDisposable: data.isDisposable,
            isSpoofable: data.isSpoofable,
            isUrlShortener: data.isUrlShortener,
            isExternalRedirect: data.isExternalRedirect
        }
    }
};

export {
    emailReputationMapper
};
